const OTP_ISSUER = 'Surglogs'

export const getOtpAuthURL = (email: string, code: string) =>
  `otpauth://totp/${OTP_ISSUER}:${email}?secret=${code}&issuer=${OTP_ISSUER}`
